<script>
export let src = ""
</script>

<img src="{src}" class="{$$props.className || ''}" alt="" />
